module.exports = __webpack_public_path__ + "img/img_throw_1@3x_v2.240bb16f.png";